import type { ErrorEvent, EventHint } from '@sentry/nextjs'
import { isTransientInfrastructureError } from '@/lib/errors'

function collectExceptionText(event: ErrorEvent): string {
  const values = event.exception?.values ?? []
  return values
    .map((entry) => [entry.type, entry.value].filter(Boolean).join(': '))
    .join(' ')
}

function isObjectCapturedExceptionMessage(message: string): boolean {
  return message.includes('Object captured as exception with keys:')
}

export function shouldDropSentryEvent(event: ErrorEvent, _hint?: EventHint): boolean {
  const exceptionText = collectExceptionText(event)
  if (exceptionText.length > 0 && isTransientInfrastructureError({ message: exceptionText })) {
    return true
  }

  const loggerArgs = event.extra?.loggerArgs
  if (loggerArgs !== undefined && isTransientInfrastructureError(loggerArgs)) {
    return true
  }

  const serialized = event.extra?.__serialized__
  if (serialized !== undefined && isTransientInfrastructureError(serialized)) {
    return true
  }

  if (
    isObjectCapturedExceptionMessage(exceptionText) &&
    ((serialized !== undefined && isTransientInfrastructureError(serialized)) ||
      (loggerArgs !== undefined && isTransientInfrastructureError(loggerArgs)))
  ) {
    return true
  }

  return false
}
